module.exports = __webpack_public_path__ + "img/2.d602bb84.png";